var i = Object.defineProperty, p = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var m = (o, e, r) => e in o ? i(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, a = (o, e) => {
  for (var r in e || (e = {}))
    s.call(e, r) && m(o, r, e[r]);
  if (t)
    for (var r of t(e))
      n.call(e, r) && m(o, r, e[r]);
  return o;
}, f = (o, e) => p(o, c(e));
import d, { forwardRef as l } from "react";
import w from "../lib/IconBase.mjs";
import R from "../defs/X.mjs";
const X = l((o, e) => /* @__PURE__ */ d.createElement(w, f(a({ ref: e }, o), { weights: R })));
X.displayName = "X";
export {
  X
};
